<template>
<div class="">
<user-top></user-top>
<div class="ht tc mt50">教育经历<span>（从高中开始）</span></div>
<div class="millia">
<ul class="expList">
<li v-for="(eduGroups,id) of eduGroup" :key="id" :id="eduGroups.id">
<p><label>学校：</label>{{eduGroups.school_name}}</p>
<p><label>学历：</label>{{eduGroups.education_text}}</p>
<p><label>专业：</label>{{eduGroups.major}}</p>
<p><label>时间：</label>{{eduGroups.start_time}} 至 {{eduGroups.end_time}}</p>
<div class="btGroup">
<!-- <span class="editBt" @click="EduEdit">编辑</span> -->
<span class="deleteBt" @click="EduDelete(eduGroups.id)">删除</span>
</div>
</li>
</ul>
<div class="layui-form" lay-filter="EduInfo">
<form action="">
<ul class="UserList">
<li>
<input type="text" name="school_name" placeholder="请尽量输入学校全称" class="layui-input" lay-verify="required" maxlength="30">
</li>
<li>
<select name="education" lay-filter="education" lay-verify="required">
<option value="">请选择学历</option>
<option v-for="educations in educationLevel" :value="educations.id" :key="educations.id">
{{educations.name}}
</option>
</select>
</li>
<li>
<input type="text" name="major" placeholder="请输入所学专业名称" class="layui-input" maxlength="30" lay-verify="required">
</li>
<li>
<input type="text" name="start_time" class="layui-input timeFlie" placeholder="开始时间" id="eduStartTime" lay-verify="required">
</li>
<li>
<input type="text" name="end_time" class="layui-input timeFlie" placeholder="毕业时间" id="eduEndTime" lay-verify="required">
</li>
<li>
<button type="button" lay-submit class="layui-btn layui-btn-fluid layui-btn-normal" lay-filter="eduSave">确认教育信息</button>
</li>
</ul>
<!-- <ul class="eduList mt20 pb20">
<li v-for="(eduItem,id) in eduGroup" :key="id">
<h6>{{eduItem.school_name}}</h6>
<span>{{eduItem.education}}</span>
<b>{{eduItem.Major}}</b>
<span>{{eduItem.start_time}} - {{eduItem.end_time}}</span>
</li>
</ul> -->
</form>
</div>
</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop.vue'
export default {
    name: "EduExp",
    inject: ["reload"],
    components:{
        UserTop
    },
    data () {
        return {
            //eduData
            educationLevel:{},  //选择学历
            eduList:{},//用户提交教育经历信息
            eduGroup:{},//获取用户已填写信息
        }
    },
    mounted () {
        //获取学历
        this.GetEducation();
        this.getEduList();

        //表单相关
        var that = this;
        layui.use('form', function(){
            var $ = layui.$;
            var form = layui.form;
            //教育经历表单提交
            form.on('submit(eduSave)', function(data){
                var BasicDatas = JSON.parse(JSON.stringify(data.field));
                that.eduList = BasicDatas;
                //console.log(that.eduList);
                that.eduSave();
            });
        });

        //时间选择
        layui.use('laydate', function(){
            var laydate = layui.laydate;
            //教育经历开始时间
            laydate.render({
                elem:'#eduStartTime',
                type:'month',
                trigger:'click',
            });
            //教育经历结束时间
            laydate.render({
                elem:'#eduEndTime',
                type:'month',
                trigger:'click',
            });
        });
    },
    updated() {
        //layui select渲染
        layui.use('form', function(){
            var form = layui.form;
            form.render('select');
        });
    },
    methods: {
        //获取学历
        GetEducation(){
            let url = "api/login/getEducationData";
            let params = {}
            this.$ajax.post(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.educationLevel = response.data.data;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //教育经历提交
        eduSave(){
            var param = {
                school_name:this.eduList.school_name,
                education:this.eduList.education,
                major:this.eduList.major,
                start_time:this.eduList.start_time,
                end_time:this.eduList.end_time
                }
            let url = "api/user/saveEduExp";
            this.$ajax.post(url,param).then(function (response) {
                if (response.data.status==1) {
                    layer.alert("教育经历保存成功");
                    this.reload();
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //获取用户教育经历信息
        getEduList() {
            let url = "api/user/getUserInfo";
            let params = {}
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.eduGroup = response.data.data.edu_exp;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //删除教育经历
        EduDelete(id){
            let url = "api/user/delEduExp";
            let params = {
                id:id
            }
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    layer.alert("教育经历删除成功!");
                    this.reload();
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
    }
}
</script>